import { render, staticRenderFns } from "./SupervisionMenu.vue?vue&type=template&id=7f72254d&scoped=true&"
import script from "./SupervisionMenu.vue?vue&type=script&lang=ts&"
export * from "./SupervisionMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SupervisionMenu.vue?vue&type=style&index=0&id=7f72254d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f72254d",
  null
  
)

export default component.exports